import { v4 as uuid } from 'uuid';

import { MESSAGES } from '../../../constants';

export interface IConnectingAgent {
  readonly id: string;
  readonly type: MESSAGES.CONNECTING_AGENT;
  readonly rm?: false;
  readonly role?: string;
}

export const connectingAgent = (data?): IConnectingAgent => ({
  id: data?.id || uuid(),
  type: MESSAGES.CONNECTING_AGENT,
});
